import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import FileSaver from 'file-saver'

import { downloadCompletePurchasesReport } from 'Services/JOONAdmin/joonAdminReportsService'

import { QueryNames } from 'Hooks/api/queryNames'

import { AppNotification } from 'Utils/types/appNotification'
import { Employer } from 'Utils/types/JOONAdmin/employer'
import { formatDateForServer } from 'Utils/helpers/dateUtils'

const completePurchasesReportFilename = (
  employerName: string,
  date: string,
  countryCode: string
) => {
  const sanitizedEmployerName = employerName.replace(/[^a-zA-Z0-9]+/g, '_')
  const month = date.substring(0, 7)
  return `${sanitizedEmployerName}_Complete_Purchases_Report_${month}_${countryCode}.xlsx`
}

export const useDownloadCompletePurchasesReport = () =>
  useMutation(
    [QueryNames.DownloadCompletePurchasesReport],
    async ({
      employerId,
      employerName,
      reportDate,
      countryCode
    }: {
      employerId: Employer['id']
      employerName: Employer['name']
      reportDate: Date
      countryCode?: string
    }) => {
      const dateString = formatDateForServer(reportDate)
      const response = await downloadCompletePurchasesReport(employerId, dateString, countryCode)
      if (response?.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        FileSaver.saveAs(
          blob,
          completePurchasesReportFilename(employerName, dateString, countryCode || 'US')
        )
        toast.success(AppNotification.ReportSyncDownloadSuccess)
      } else {
        toast.error(AppNotification.ReportSyncDownloadFailure)
      }
    },
    {
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || AppNotification.ReportSyncDownloadFailure
        toast.error(errorMessage)
        return undefined
      }
    }
  )
